/* eslint-disable react/prop-types */
import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';

import ContractTextBlock from './ContractTextBlock';
import ContractTitle from './ContractTitle';
import ContractSubtitle from './ContractSubtitle';
import ContractImage from './ContractImage';
import ContractFiles from './ContractFiles';

const componentsMap = {
  title: ContractTitle,
  subtitle: ContractSubtitle,
  multiLineParagraph: ContractTextBlock,
  singleImage: ContractImage,
  collapseRow: ContractFiles,
};

const StyledBox = styled(Box)`
  b {
    font-weight: bold;
  }
  
`;

const ContractMap = ({ page }) => (
  <StyledBox
    paddingHorizontal={{ xs: '0', md: '16x' }}
    marginBottom="16x"
  >
    {page.map(item => {
      const key = Object.keys(item)[1];
      const value = item[key];

      if (!item.id || !key) {
        throw new Error('getContent() elements query must include an id');
      }

      const DynamicComponent = componentsMap[key];

      if (!DynamicComponent) return null;

      return <DynamicComponent key={item.id} data={value} />;
    })}
  </StyledBox>
);

export default ContractMap;
